import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Cleave from 'cleave.js/react';
import { Input, AlertNotice } from 'shared/components';
import { ValidationService } from 'shared/services';
import {
  nonPersonnelValidationRules,
  nonPersonnelErrorStrings,
} from 'shared/validations';
import isEmpty from 'lodash/isEmpty';
import './AddNonPersonnelStaff.scss';

const AddNonPersonnelStaff = ({
  handleSubmit,
  handleCancel,
  showError,
}) => {
  const { t } = useTranslation();
  const [nonPersonnel, setNonPersonnel] = useState({
    firstName: '',
    lastName: '',
    emailAddress: '',
    phone: '',
  });

  const [errors, setErrors] = useState({});


  const handleChange = (e) => {
    setNonPersonnel({ ...nonPersonnel, [e.target.name]: e.target.value });
  };

  const handlePhoneChange = (e) => {
    setNonPersonnel({ ...nonPersonnel, [e.target.name]: e.target.rawValue });
  };

  const handleNonPersonnelSubmit = (e) => {
    e.preventDefault();
    const validationErrors = ValidationService.validate(
      nonPersonnel,
      nonPersonnelValidationRules,
      nonPersonnelErrorStrings
    );
    if (isEmpty(validationErrors)) {
      handleSubmit(nonPersonnel);
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="non-personnel-profile">
      <div className="pb-3 staff-information-message">
        {t(
          'staffAndRoomsManagement.assignStaff.AddStaffInformationMessage'
        )}
      </div>
      <form className="list-group list-group-flush" noValidate>
        <div className="list-group-item">
          <Input
            type="text"
            name="lastName"
            id="NonPersonnelLastName"
            label="forms.labels.lastName"
            value={nonPersonnel.lastName}
            onChange={handleChange}
            errors={errors.lastName}
            required
          />
        </div>
        <div className="list-group-item">
          <Input
            type="text"
            name="firstName"
            id="NonPersonnelFirstName"
            value={nonPersonnel.firstName}
            label="forms.labels.firstName"
            onChange={handleChange}
            errors={errors.firstName}
            required
          />
        </div>
        <div className="list-group-item">
          <div className="input-container">
            <label
              htmlFor="NonPersonnelPhone"
              // eslint-disable-next-line quotes
              className={`${errors.phone ? "label-error" : ""} fw-bold`}
            >
              {t('staffAndRoomsManagement.assignStaff.phone')}
            </label>
            <Cleave
              className={errors.phone ? 'error' : ''}
              name="phone"
              id="NonPersonnelPhone"
              options={{
                phone: true,
                phoneRegionCode: 'US',
                delimiter: '-',
              }}
              value={nonPersonnel.phone}
              onChange={handlePhoneChange}
              errors={errors.phone}
              required
            />
            {errors.phone
              && errors.phone.map((error) => (
                <span className="text-error font-size-12" key={error}>
                  {t(error)}
                </span>
              ))}
          </div>
        </div>
        <div className="list-group-item">
          <Input
            type="text"
            name="emailAddress"
            id="NonPersonnelEmailAddress"
            value={nonPersonnel.emailAddress}
            onChange={handleChange}
            label="common.labels.email"
            errors={errors.emailAddress}
            required
          />
        </div>
        {
                  showError
                  && <AlertNotice message={t('errors.serverError')} inline type="error" />
                 }

        <div className="buttons-container bottom-container">
          <button type="button" onClick={handleCancel} className="btn w-50">
            {t('common.labels.back')}
          </button>
          <button
            type="submit"
            className="btn btn-primary w-50 "
            onClick={handleNonPersonnelSubmit}
          >
            {t('common.labels.continue')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddNonPersonnelStaff;

AddNonPersonnelStaff.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  showError: PropTypes.bool,
};

AddNonPersonnelStaff.defaultProps = {
  showError: false,
};
